import { Divider } from '@mui/material';
import type React from 'react';

const ToolbarDivider: React.FC = () => {
	return <Divider orientation="vertical" flexItem />;
};

export default ToolbarDivider;
